import { SvgIcon, SvgIconProps } from "@mui/material";
import { memo } from "react";
const SvgArrowMediumRight32 = (props: SvgIconProps) => {
  const {
    sx,
    ...other
  } = props;
  return <SvgIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" sx={{
    ...sx
  }} {...other}><path fill="currentColor" d="M12.646 9.646a.5.5 0 0 1 .708 0L19.707 16l-6.353 6.354a.5.5 0 0 1-.708-.708L18.293 16l-5.647-5.646a.5.5 0 0 1 0-.708" /></SvgIcon>;
};
const Memo = memo(SvgArrowMediumRight32);
export default Memo;